import { MapProvider } from '../providers/mapProvider';
import { AsyncAction } from '../../base-classes/asyncAction';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_MAP_LAYERS = new AsyncAction('GET_MAP_LAYERS');
export const GET_MAP_METADATA = new AsyncAction('GET_MAP_METADATA');
export const GET_LAYER_LEGEND = new AsyncAction('GET_LAYER_LEGEND');
export const GET_ALERTS_LEGEND = new AsyncAction('GET_ALERTS_LEGEND');

export function getMapLayers(...params) {
    let paramsObject = {
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        latitude: undefined,
        longitude: undefined,
        stdParameters: undefined,
        tempUnit: undefined,
        pressureUnit: undefined
    };
    paramsObject = mapParamsToObject(params, paramsObject);
    return {
        type: GET_MAP_LAYERS.base,
        payload: getMapLayersAsync(paramsObject)
    };
}

async function getMapLayersAsync({ baseUrl, authId, secret, latitude, longitude, stdParameters, tempUnit, pressureUnit }) {
    const provider = new MapProvider(baseUrl, authId, secret);
    return await provider.getMapLayers(latitude, longitude, stdParameters, tempUnit, pressureUnit);
}

export function getMapMetadata(...params) {
    let paramsObject = {
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        layerId: undefined,
        stdParameters: undefined,
        verbose: undefined,
        refresh: undefined
    };
    paramsObject = mapParamsToObject(params, paramsObject);
    return {
        type: GET_MAP_METADATA.base,
        payload: getMapMetadataAsync(paramsObject)
    };
}

async function getMapMetadataAsync({ baseUrl, authId, secret, layerId, stdParameters, verbose, refresh }) {
    const provider = new MapProvider(baseUrl, authId, secret);
    return await provider.getMapMetadata(layerId, stdParameters, verbose, refresh);
}

export function getLayerLegend(...params) {
    let paramsObject = {
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        layerId: undefined,
        stdParameters: undefined,
        refresh: undefined
    };
    paramsObject = mapParamsToObject(params, paramsObject);
    return {
        type: GET_LAYER_LEGEND.base,
        payload: getLayerLegendAsync(paramsObject)
    };
}

async function getLayerLegendAsync({ baseUrl, authId, secret, layerId, stdParameters, refresh }) {
    const provider = new MapProvider(baseUrl, authId, secret);
    return await provider.getLayerLegend(layerId, stdParameters, refresh);
}

export function getAlertsLegend(...params) {
    let paramsObject = {
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        width: undefined,
        height: undefined,
        north: undefined,
        east: undefined,
        south: undefined,
        west: undefined,
        latitude: undefined,
        longitude: undefined,
        timeslot: undefined,
        mapZoomLevel: undefined,
        stdParameters: undefined,
        refresh: undefined
    };
    paramsObject = mapParamsToObject(params, paramsObject);
    return {
        type: GET_ALERTS_LEGEND.base,
        payload: getAlertsLegendAsync(paramsObject)
    };
}

async function getAlertsLegendAsync({ baseUrl, authId, secret, width, height, north, east, south, west, latitude, longitude, timeslot, mapZoomLevel, stdParameters, refresh }) {
    const provider = new MapProvider(baseUrl, authId, secret);
    return await provider.getAlertsLegend(width, height, north, east, south, west, latitude, longitude, timeslot, mapZoomLevel, stdParameters, refresh);
}
